/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function isBultinErrorName(errorName) {
  switch (errorName) {
    case 'EvalError':
    case 'InternalError':
    case 'RangeError':
    case 'ReferenceError':
    case 'SyntaxError':
    case 'TypeError':
    case 'URIError':
      return true;
    default:
      return false;
  }
}

export { isBultinErrorName };
export default isBultinErrorName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-error-overlay/lib/utils/isBultinErrorName.js
// module id = ./node_modules/react-error-overlay/lib/utils/isBultinErrorName.js
// module chunks = 0